import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { default as Svg } from '@mui/material/SvgIcon';
import { forwardRef } from 'react';
const SvgCalendarLock1 = (props, ref) => (_jsxs(Svg, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: ref, ...props, children: [_jsx("path", { d: "M12.5 18.5h-11a1 1 0 0 1-1-1v-14a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v6M5.5.501v5M15.5.501v5M.5 7.501h20", style: {
                fill: 'none',
                stroke: 'currentColor',
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
            } }), _jsx("rect", { width: 9, height: 7.999, x: 14.5, y: 15.501, rx: 1, ry: 1, style: {
                fill: 'none',
                stroke: 'currentColor',
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
            } }), _jsx("circle", { cx: 19, cy: 19.564, r: 1.25, style: {
                fill: 'none',
                stroke: 'currentColor',
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
            } }), _jsx("path", { d: "M21.5 14a2.5 2.5 0 1 0-5 0v1.5h5Z", style: {
                fill: 'none',
                stroke: 'currentColor',
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
            } })] }));
const ForwardRef = forwardRef(SvgCalendarLock1);
export default ForwardRef;
